import { Injectable } from '@angular/core';
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth, signInAnonymously, User, onAuthStateChanged, signOut } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getDatabase, Database } from 'firebase/database';
import { getFunctions, Functions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider, AppCheck } from 'firebase/app-check';
import { BehaviorSubject, Observable } from 'rxjs';

const firebaseConfig = {
    apiKey: "AIzaSyCvBjlvW-t1aJauE0iTo8a9bgGqGMVk0Ek",
    authDomain: "babymonitor-live.firebaseapp.com",
    projectId: "babymonitor-live",
    storageBucket: "babymonitor-live.firebasestorage.app",
    messagingSenderId: "266130048548",
    appId: "1:266130048548:web:82656f3efb56a3deae3ab1",
    measurementId: "G-QCTTZQ79GS"
};

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private app: FirebaseApp;
    private auth: Auth;
    private db: Firestore;
    private rtdb: Database;
    private fns: Functions;
    private appCheck?: AppCheck;

    private userSubject = new BehaviorSubject<User | null>(null);
    user$: Observable<User | null> = this.userSubject.asObservable();

    constructor() {
        this.app = initializeApp(firebaseConfig);
        this.auth = getAuth(this.app);
        this.db = getFirestore(this.app);
        this.rtdb = getDatabase(this.app);
        this.fns = getFunctions(this.app);

        // Initialize App Check to protect against token replay attacks.
        // SETUP: Register your site at https://console.firebase.google.com/project/babymonitor-live/appcheck
        // then replace RECAPTCHA_V3_SITE_KEY with the key from Project Settings > App Check.
        const RECAPTCHA_V3_SITE_KEY = ''; // TODO: fill in from Firebase Console > App Check
        if (typeof window !== 'undefined') {
            if (window.location.hostname.includes('localhost')) {
                (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
            } else if (RECAPTCHA_V3_SITE_KEY) {
                this.appCheck = initializeAppCheck(this.app, {
                    provider: new ReCaptchaV3Provider(RECAPTCHA_V3_SITE_KEY),
                    isTokenAutoRefreshEnabled: true
                });
            }
        }

        onAuthStateChanged(this.auth, (user) => {
            if (user) {
                this.userSubject.next(user);
            } else {
                // Auto-sign in anonymously if not signed in
                this.signInAnonymously();
            }
        });
    }

    async signInAnonymously() {
        try {
            await signInAnonymously(this.auth);
        } catch (error) {
            console.error("Error signing in anonymously", error);
        }
    }

    async logout() {
        return signOut(this.auth);
    }

    get functions(): Functions {
        return this.fns;
    }

    get currentUser(): User | null {
        return this.auth.currentUser;
    }

    get firestore(): Firestore {
        return this.db;
    }

    get realtimeDb(): Database {
        return this.rtdb;
    }
    async getToken(): Promise<string | null> {
        if (!this.auth.currentUser) return null;
        return this.auth.currentUser.getIdToken();
    }

    get token$(): Observable<string | null> {
        // Simple implementation: emit token whenever user changes
        // In real app, listen to onIdTokenChanged
        return new Observable(observer => {
            return this.auth.onIdTokenChanged(async (user) => {
                if (user) {
                    const token = await user.getIdToken();
                    observer.next(token);
                } else {
                    observer.next(null);
                }
            });
        });
    }
}
